// Import packages
import React, { useState, useEffect } from "react";
import { Select, MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields, alertState } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

export default function Stop({ action, variables, setOpenVariable, fromEventConf }) {

  const [content, setContent] = useState("noData");
  const setAlert = useSetRecoilState(alertState);

  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
  const [code, setCode] = useState({ isOk: false, value: "" });

  const variableRegex = /##[^\s][^#]+?[^\s]##/
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STOP.";

  useEffect(() => {
    if (!action.fields.responseType) {
      action.fields.responseType = { value: "noData", isRequired: true };
    } else {
      setContent(action.fields.responseType.value);
    }
  }, [action]);

  const handleContentSelect = (event) => {
    if (event.target.value === "noData") {
      action.fields.responseData.value = "";
      action.fields.responseData.htmlValue = "";
    }
    let value = event.target.value;
    action.fields.responseType.value = value;

    const field = initialActionsData[action.id]?.fields.responseType;
    const oldValue = !field ? undefined : field.value;

    CheckIfFlowUpdated("responseType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);

    setContent(value);
  };

  const isValidCode = (e) => {
    if (e && e.target) {
      let v = e.target.outerText;
      if (v && v !== "\n") {
        if (!variableRegex.test(v)) {
          let num = parseInt(v)
          if (!num || (num < 100 || num > 999)) {
            setCode({ isOk: new Date(), value: "" });
            setAlert(alert => ({ ...alert, show: true, message: t(label + 'INVALID-INPUT', { value: v }), severity: 'error' }));
          }
        }
      }
    }

  }

  return (
    <div>
      <div className="form-element">
        <FieldLabel name={t('CONTENT.CONFIGURATION-FORM.STOP.RESPONSE-STATUS-CODE')} />
        <TextInput
          action={action}
          inputName="responseStatusCode"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          onBlur={isValidCode}
          outNewValue={code}
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.STOP.RESPONSE-STATUS-CODE-INFO')}</em></small>
        <div><small><em>{t('CONTENT.CONFIGURATION-FORM.STOP.RESPONSE-STATUS-CODE-INFO2')}</em></small></div>
      </div>
      <div className="form-element">
        <FieldLabel name={t('CONTENT.CONFIGURATION-FORM.STOP.ERROR-MESSAGE')} />
        <TextInput
          action={action}
          inputName="responseErrorMessage"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.STOP.RESPONSE-ERROR-MESSAGE-INFO')}</em></small>
      </div>
      <div className="form-element">
        {t("CONTENT.CONFIGURATION-FORM.STOP.RESPONSE-TYPE")}
        <Select
          value={content}
          onChange={handleContentSelect}
          variant="outlined"
          fullWidth
          style={{ width: "90%", backgroundColor: "#FCFCFC" }}
        >
          <MenuItem value="noData">{t("CONTENT.CONFIGURATION-FORM.STOP.NO-DATA")}</MenuItem>
          <MenuItem value="application/json">application/json</MenuItem>
          <MenuItem value="application/xml">application/xml</MenuItem>
          <MenuItem value="text/plain">text/plain</MenuItem>
          <MenuItem value="text/xml">text/xml</MenuItem>
          <MenuItem value="text/html">text/html</MenuItem>
        </Select>
      </div>
      {content !== "noData" && (
        <div className="form-element">
          <TextInput
            action={action}
            inputName="responseData"
            variables={variables}
            setOpenVariable={setOpenVariable}
            multiline
            rows={4}
            isRequired={false}
          />
          {
            !fromEventConf ?
              <small>
                {"message : ''"}<br />
                {"status: ''"}<br />
                data: {action.fields.responseData?.value ? action.fields.responseData?.value : '{}'}
              </small> :
              <small>
                <em>
                  {t(label + "RESPONSE-DATA-INFO")}<br />
                  {t(label + (content === "application/json" ? "OBJECT-RESPONSE-DATA-INFO" : "STRING-RESPONSE-DATA-INFO"))}
                </em>
              </small>
          }

        </div>
      )}
    </div>
  );
}
